import * as React from "react";

const SVGComponent = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.6234 8.38754L12.6236 4.37757C12.1214 3.87414 11.3036 3.87414 10.8014 4.37757L4.37661 10.8187C3.87446 11.3221 3.87446 12.1421 4.37661 12.6455L7.55732 15.8343C7.55732 15.8343 7.56851 15.843 7.57348 15.848C7.66421 15.9414 7.78975 16 7.9302 16H15.6601C15.9348 16 16.1573 15.7769 16.1573 15.5016C16.1573 15.2262 15.9348 15.0031 15.6601 15.0031H11.8467L16.6234 10.2143C17.1255 9.7109 17.1255 8.89097 16.6234 8.38754ZM8.13405 15.0031L5.07888 11.9402C4.96453 11.8255 4.96453 11.6386 5.07888 11.5227L8.87857 7.7134L13.2948 12.1408L10.441 15.0019H8.13405V15.0031ZM15.9199 9.51028L13.9983 11.4368L9.58208 7.00935L11.5037 5.08287C11.618 4.96822 11.8045 4.96822 11.9201 5.08287L15.9199 9.09283C15.9758 9.14891 16.0056 9.22243 16.0056 9.30093C16.0056 9.37944 15.9746 9.45421 15.9199 9.50903V9.51028Z"
      fill={props.color || "#4F4F4F"}
    />
  </svg>
);

export default SVGComponent;
